module.exports = __webpack_public_path__ + "static/img/natasha_pictgrid17_980x829.ae2e686.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/natasha_pictgrid17_980x829.jpg
// module id = OEEt
// module chunks = 0